import React from 'react';


export default function CartEmpty() {

    return <div style={{textAlign: "center"}}>
        <h2>Twój koszyk jest pusty</h2>
    </div>
}